import React, { useState } from "react";
import { auth, db } from "./firebase"; // Import auth and db
import { useNavigate } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore"; // Import Firestore methods
import './login.css'; // Your custom CSS for login page

function Login() {
    const auth = getAuth(); // Ensure auth is initialized


  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

 const handleLogin = async (e) => {
  e.preventDefault();
  setError(""); // Reset error messages

  if (!email || !password) {
    setError("Please fill in both email and password.");
    return;
  }

  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user; // Get user immediately after login

    console.log("Logged in user:", user);

    if (user) {
      navigate("/body"); // Navigate to the dashboard if login is successful
    } else {
      setError("Failed to retrieve user information.");
    }
  } catch (err) {
    console.error("Login error: ", err);
    setError("Failed to login. Please check your credentials.");
  }
};


  return (
<div className="eol-login-wrapper">
  <div className="eol-login-card">
    
    <div className="eol-logo-section">
      <img 
        src="login panel logo.png" 
        alt="Ekanayake Optical" 
        className="eol-logo-image" 
      />
    </div>

    <h2 className="eol-login-title"></h2>
    
    <p className="eol-login-description">
      Please log in to access your dashboard and manage your services efficiently.
    </p>

    <form onSubmit={handleLogin} className="eol-login-form">
      <div className="eol-input-group">
        <label className="eol-input-label">Email Address</label>
        <input
          type="email"
          className="eol-input-field"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          placeholder="Enter your email"
        />
      </div>

      <div className="eol-input-group">
        <label className="eol-input-label">Password</label>
        <input
          type="password"
          className="eol-input-field"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          placeholder="Enter your password"
        />
      </div>

      <button className="eol-login-button" type="submit">
        <span className="eol-button-icon">🔐</span>
        Sign In
      </button>
    </form>

    {error && (
      <div className="eol-error-message">
        <span className="eol-error-icon">⚠️</span>
        {error}
      </div>
    )}

    <div className="eol-footer">
      <img 
        src="glaxmore_logo.png" 
        alt="GLAXMORE" 
        className="eol-powered-logo" 
      />
      <p className="eol-powered-text">
        Powered by 
        <a 
          className="eol-powered-link" 
          href="https://www.glaxmore.com" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          GLAXMORE
        </a>
      </p>
    </div>

  </div>
</div>
  );
}

export default Login;